import * as THREE from 'three'
import Experience from '../../Experience.js'
import * as CANNON from 'cannon-es'

export default class Pallettruck {
    constructor() {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources
        this.physics = this.experience.physics

        this.setModel()
        this.setPhysics()
        this.setRandomRotation()
    }

    setModel()
    {
        this.model = this.resources.items.palletTruckModel.clone()
        // Get model outer dimensions
        let bbox = new THREE.Box3().setFromObject(this.model);
        this.dimensions = bbox.getSize(new THREE.Vector3());

        this.scene.add(this.model)
    }

    setPosition(x, z)
    {
        // Set position of mesh
        this.model.position.set(x, 4, z)
        // Set position of physics body
        this.body.position.set(x, 4, z)
    }

    setRandomRotation()
    {
        // Set rotation of mesh
        this.model.rotation.y = Math.random() * Math.PI * 2
        // Set rotation of physics body
        this.body.quaternion.setFromAxisAngle(new CANNON.Vec3(0, 1, 0), this.model.rotation.y)
    }

    setPhysics()
    {
        this.body = new CANNON.Body({ mass: 80 })

        // Create horizontal shape
        const horizontalShape = new CANNON.Box(new CANNON.Vec3(this.dimensions.x / 2, 0.2, this.dimensions.z / 2))
        this.body.addShape(horizontalShape, new CANNON.Vec3(0.12, 0, 0.5))

        // Create vertical shape
        const verticalShape = new CANNON.Box(new CANNON.Vec3(this.dimensions.x / 2, this.dimensions.y / 2, 0.2))
        this.body.addShape(verticalShape, new CANNON.Vec3(0.12, 0.6, -0.7))

        this.physics.world.addBody(this.body)
        this.physics.objectsToUpdate.push({
            mesh: this.model,
            body: this.body
        })
    }
}